import React, { useRef, useLayoutEffect, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Component from './FilterAccordion.styles'

const FilterAccordion = (props) => {
  const {
    id,
    title,
    open,
    checked,
    deactivated,
    variant,
    handleOpen,
    children,
    ...rest
  } = props

  const panelRef = useRef(null)
  const timer = React.useRef(null)

  /**
   * clean up on component destroy
   */
  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    },
    [timer]
  )

  /**
   * get initial height and set open state
   */
  useLayoutEffect(() => {
    if (!panelRef.current) return

    // TODO hwo to get real height (not whole scrollHeight)????
    const { scrollHeight } = panelRef.current
    if (timer.current) {
      clearTimeout(timer.current)
    }

    const onTransitionComplete = () => {
      panelRef.current.style.height = 'auto'
      panelRef.current.style.overflow = 'visible'
      panelRef.current.removeEventListener(
        'transitionend',
        onTransitionComplete
      )
    }

    if (open) {
      panelRef.current.addEventListener('transitionend', onTransitionComplete)
      panelRef.current.style.height = `${ scrollHeight }px`
    } else {
      panelRef.current.style.height = `${ scrollHeight }px`
      panelRef.current.style.overflow = 'hidden'
      timer.current = setTimeout(() => {
        panelRef.current.style.height = '0px'
      }, 0)
    }
  }, [open])

  return (
    <Component.Container id={ id } { ...rest }>
      <Component.PanelButton
        aria-expanded={ open }
        onClick={ handleOpen }
        tabIndex='-1'
        deactivated={ deactivated }
        variant={ variant }
        title={ title }>
        <div className='title-row'>
          <span>{title}</span>
        </div>

        {checked && <Component.CheckIcon className='icon-f-checkmark' />}
      </Component.PanelButton>
      <Component.PanelBody
        open={ open }
        ref={ panelRef }
        variant={ variant }
        deactivated={ deactivated }>
        {variant === 'default' && (
          <Component.ChildrenWrapper>{children}</Component.ChildrenWrapper>
        )}
        {variant === 'select' && children}
      </Component.PanelBody>
    </Component.Container>
  )
}

FilterAccordion.defaultProps = {
  open: false,
  variant: 'default',
  // TODO remove
  loadMore: false,
}

FilterAccordion.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
  /** If true, display check icon  */
  checked: PropTypes.bool,
  /**
   * default => act as filter accordion (grouped filters)
   * select => act as select accordion (sort option)
   */
  variant: PropTypes.oneOf(['default', 'select']),
  /**
   * Fired when accordion title is clicked
   * Signature: function() {...}
   */
  handleOpen: PropTypes.func.isRequired,
  deactivated: PropTypes.bool,
  children: PropTypes.node,
  loadMore: PropTypes.bool,
}

export default FilterAccordion
